import { useEffect } from "react";
import AdminTabs from "../adminTabs";
import { ThreeCircles } from "react-loader-spinner";

import { useQsrController } from "./QsrController";
import QsrDashboard from "./QSRDashboard";
import useThermalPrinter from "./hooks/useThermalPrinter";

const QsrVendor = () => {
  const qsr = useQsrController();
  const printer = useThermalPrinter();

  // Wire auto-print: when WebSocket receives a new order, print it
  useEffect(() => {
    qsr.onNewOrderRef.current = (order) => {
      printer.autoPrint(order);
    };
    return () => {
      qsr.onNewOrderRef.current = null;
    };
  }, [printer.autoPrint]);

  return (
    <AdminTabs>
      {qsr.loading && (
        <div className="spinnerContainer">
          <div className="spinner">
            <ThreeCircles
              height={110}
              width={110}
              color="blue"
              ariaLabel="loading"
            />
          </div>
        </div>
      )}

      {!qsr.loading && (
        <QsrDashboard
          /* Kitchen */
          kitchens={qsr.kitchens}
          selectedKitchen={qsr.selectedKitchen}
          setSelectedKitchen={qsr.setSelectedKitchen}

          /* Clients */
          clients={qsr.clients}
          selectedClient={qsr.selectedClient}
          setSelectedClient={qsr.setSelectedClient}
          handleClientToggle={qsr.handleClientToggle}

          /* Data */
          menus={qsr.menus}
          orders={qsr.orders}
          categories={qsr.categories}

          /* Tabs */
          activeOrderTab={qsr.activeOrderTab}
          setActiveOrderTab={qsr.setActiveOrderTab}
          setActiveDashboardTab={qsr.setActiveDashboardTab}

          /* Actions */
          reloadMenus={qsr.reloadMenus}
          reloadOrders={qsr.reloadOrders}
          handleToggleMenu={qsr.handleToggleMenu}
          updateBufferCount={qsr.updateBufferCount}
          openLiveCounter={qsr.openLiveCounter}
          saveMenu={qsr.saveMenu}
          deleteMenu={qsr.deleteMenu}
          saveHotSellingItems={qsr.saveHotSellingItems}
          updateOrderStatus={qsr.updateOrderStatus}
          bulkUpdateOrderStatus={qsr.bulkUpdateOrderStatus}
          placeOrder={qsr.placeOrder}
          pendingOrderActions={qsr.pendingOrderActions}
          orderActionErrors={qsr.orderActionErrors}
          gstConfig={qsr.gstConfig}

          /* Printer */
          printer={printer}
        />
      )}
    </AdminTabs>
  );
};

export default QsrVendor;
